module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality.3180fb78.jpg";